export default __webpack_public_path__ + "static/ReferAFriendBannerNintendoSwitchTwo-be55dc8ae431127cd6af605f0f0d778b.jpg";